<template>
  <span v-if="hasProductInvoice">
    <DocumentAnalysisBadge
      :verdict="analysisVerdict"
      :is-analyzed="Boolean(productInvoiceAnalyzedAt)"
      :has-error="analysisHasError"
      :tooltip="analysisBadgeLabel"
      :clickable="canOpenAnalysisModal"
      @click="analysisModalOpen = true"
    />
    <PurchaseInvoiceAnalysisModal
      :open="analysisModalOpen"
      :analysis="productInvoiceAnalysis"
      :analyzed-at="productInvoiceAnalyzedAt"
      :analysable-id="declaration.id"
      analysable-type="Claims::Declaration"
      :claim-active="claimActive"
      @close="analysisModalOpen = false"
      @retry-success="$emit('retry-success')"
    />
  </span>
</template>

<script>
import { useI18n } from "vue-i18n";
import DocumentAnalysisBadge from "@/components/claim/details/DocumentAnalysisBadge.vue";
import PurchaseInvoiceAnalysisModal from "@/components/claim/details/PurchaseInvoiceAnalysisModal.vue";
import { verdictLabel } from "@/components/claim/details/purchaseInvoiceAnalysisFormatter";

export default {
  components: {
    DocumentAnalysisBadge,
    PurchaseInvoiceAnalysisModal,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  emits: ["retry-success"],
  props: {
    declaration: {
      type: Object,
      default: null,
    },
    claimActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      analysisModalOpen: false,
    };
  },

  computed: {
    hasProductInvoice() {
      return (this.declaration?.productInvoice?.length || 0) > 0;
    },
    productInvoiceAnalysis() {
      return this.declaration?.productInvoiceAnalysis || null;
    },
    productInvoiceAnalyzedAt() {
      return this.declaration?.productInvoiceAnalyzedAt || null;
    },
    analysisVerdict() {
      return this.declaration?.productInvoiceAnalysisVerdict || null;
    },
    analysisHasError() {
      return Boolean(this.productInvoiceAnalysis?.error);
    },
    canOpenAnalysisModal() {
      return Boolean(this.productInvoiceAnalyzedAt) || this.analysisHasError;
    },
    analysisBadgeLabel() {
      if (this.analysisHasError) return this.t("unavailable");
      if (!this.productInvoiceAnalyzedAt) return this.t("not_analyzed");
      return verdictLabel(this.analysisVerdict);
    },
  },
};
</script>

<i18n src="./PurchaseInvoiceAnalysisBadge.i18n.json"></i18n>
